import { useContext } from "react"

import { NavContext } from "../providers/nav"

export const useNav = () => {
  const nav: any = useContext(NavContext)
  return { ...nav }
}
